import React, { useRef } from 'react'
import { Avatar, Button, CloseButton, Flex, FlexProps, FormControl, Input, Text, useDisclosure } from '@chakra-ui/react'
import { ResourceEstimate } from '../types'
import { FiChevronsRight, FiEdit } from 'react-icons/fi'
import { useQuery } from '../convex/_generated/react'
import ResourcesPicker from '../components/Modals/ResourcesPicker'
import ResourceFormModal from '../components/Modals/ResourceFormModal'

interface IProps extends ResourceEstimate, Omit<FlexProps, 'resource' | 'onChange'> {
  onDelete?: () => void
  onChange?: (resource: Omit<ResourceEstimate, 'resource'>) => void
}

const Resource: React.FC<IProps> = ({
  resource,
  pricingType,
  actualCost,
  chargePrice,
  hours,
  onDelete,
  onChange,
  ...rest
}) => {
  console.log(`fetching ${resource}`)
  const res = useQuery('resourceById', resource || null)
  const formData = useRef<ResourceEstimate>({})
  const throttleKey = useRef<any>()

  const { isOpen, onClose, onOpen } = useDisclosure()
  const { isOpen: resourceEditIsOpen, onOpen: onOpenResourceEdit, onClose: closeEditResource } = useDisclosure()

  /** Trigger change only after half second of idle activity */
  const handleChange = (key: keyof ResourceEstimate, value: any) => {
    onClose()
    formData.current[key] = value
    clearTimeout(throttleKey.current)
    throttleKey.current = setTimeout(() => {
      onChange && onChange(formData.current)
    }, 500)
  }

  const handleEdit = (e: any) => {
    if (!resource) {
      return
    }
    e.stopPropagation()
    onOpenResourceEdit()
  }

  return (
    <div>
      <Flex alignItems={'stretch'} align={'center'} gap={3} {...rest}>
        <Flex cursor="pointer" justifyContent={'space-between'} minWidth={300} onClick={onOpen} align={'center'} p={2} borderWidth={1} gap={2} borderRadius={6}>
          <Flex align={'center'} gap={3}>
            <Avatar name={res ? res.name : 'A'} />
            <Flex direction="column">
              <Text fontSize="md">{ res ? res.name : 'Select Resource' }</Text>
              <Text fontSize="sm">{ res ? res.designation : '' }</Text>
            </Flex>
          </Flex>
          <Flex align="center" gap={2}>
            {
              resource
                ? <Button onClick={handleEdit}><FiEdit /></Button>
                : null
            }
            <FiChevronsRight />
          </Flex>
        </Flex>
        {/*
        <Flex align={'center'} p={2} borderWidth={1} gap={2} borderRadius={6}>
          <RadioGroup defaultValue={pricingType} onChange={(val) => handleChange('pricingType', val)}>
            <Stack direction="row">
              <Radio value={PRICING_TYPE_FIXED}>Fixed</Radio>
              <Radio value={PRICING_TYPE_HOURLY}>Hourly</Radio>
            </Stack>
          </RadioGroup>
        </Flex>
        */}
        <FormControl>
          <Text as="label" fontSize="sm">Actual hourly cost</Text>
          <Input type="number" mt={2} defaultValue={actualCost} placeholder="Actual cost" onChange={(e) => handleChange('actualCost', parseFloat(e.target.value))} />
        </FormControl>
        <FormControl>
          <Text as="label" fontSize="sm">Hourly charge price</Text>
          <Input mt={2} type="number" defaultValue={chargePrice} placeholder="Hourly charge price" onChange={(e) => handleChange('chargePrice', parseFloat(e.target.value))} />
        </FormControl>
        <FormControl>
          <Text as="label" fontSize="sm">Total hours</Text>
          <Input mt={2} type="number" defaultValue={hours} placeholder="Total hours" onChange={(e) => handleChange('hours', parseFloat(e.target.value))} />
        </FormControl>
        <CloseButton onClick={onDelete} borderRadius={100} fontSize={15} size={'lg'} />
      </Flex>
      <ResourcesPicker
        isOpen={isOpen}
        onSelect={(res, id) => {
          handleChange('resource', id)
          handleChange('actualCost', res.rate)
        }}
        onClose={onClose}
      />
      <ResourceFormModal
        _id={resource}
        isOpen={resourceEditIsOpen}
        onClose={closeEditResource}
      />
    </div>
  )
}

export default Resource
